import ReactDOM from 'react-dom';
import './index.css';

const element = <h1 className='HelloWorld'> A Simple React App </h1>;

ReactDOM.render(element, document.getElementById('root'));
